import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {  onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { MessageDialog } from '../../../framework/frontend/MessageDialog';
import { UsersService } from '../../biz/remote/UsersService';
import { Messages } from '../../utils/Messages';
import { SessionUser } from '../../utils/SessionUser';
import { DialogHandler } from './DialogHandler';
import CoreDialog from '../../../framework/components/dialog/CoreDialog.vue';
import { translation } from '../../lang/Translation';
/**
 * 動的ラベル
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'ContactUsDialog',
  setup(__props) {

const title = translation.to("お問い合わせ","contact_us_title")

/**
 * プロパティ
 */
const dialogId = DialogHandler.contactUsDialogId;

const route = useRoute();
const user_id = ref(SessionUser.instance.userId);
const mail = ref('');
const user_name = ref('');
const project_id = ref(route.params.project_id);
const comment = ref('');

/**
 * ユーザー情報取り直し
 */
onMounted(() => {
  DialogHandler.onOpenDialog(dialogId, function () {
    const userBiz = new UsersService();
    userBiz.getUser(user_id.value).then((response) => {
      const user = response.data;
      mail.value = user.mail;
      user_name.value = user.name;
    });
  });
});

const sendMessage = async () => {
  let text = '';
  text += `メールアドレス:${mail.value}\n`;
  text += `【お問い合わせ内容】\n`;
  text += comment.value;
  text += '\n\n---\n';
  text += `ユーザー名[ID]:${user_name.value}[${user_id.value}]\n`;
  text += `プロジェクトID:${project_id.value}\n`;
  text += `UA:${window.navigator.userAgent}\n`;
  await Messages.postSlack(text, '', user_name.value);
  MessageDialog.info(
    '<b>お問い合わせ誠にありがとうございます。</b><BR>内容検討の上、早急に登録いただいたメールアドレスにご返信をさせていただきます。<br>万が一返信がない場合には、お手数ですがinfo@levelenter.comまでメールにてお問い合わせください。'
  );
  DialogHandler.hideDialog(DialogHandler.contactUsDialogId);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CoreDialog, {
    id: _unref(dialogId),
    "dialog-class": { 'modal-md': true },
    title: _unref(title)
  }, {
    footer: _withCtx(() => [
      _createElementVNode("button", {
        class: "btn btn-primary",
        onClick: sendMessage
      }, "送信")
    ]),
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((project_id).value = $event)),
        type: "hidden"
      }, null, 512), [
        [_vModelText, project_id.value]
      ]),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((user_id).value = $event)),
        type: "hidden"
      }, null, 512), [
        [_vModelText, user_id.value]
      ]),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((user_name).value = $event)),
        type: "hidden"
      }, null, 512), [
        [_vModelText, user_name.value]
      ]),
      _createElementVNode("p", null, [
        _createElementVNode("span", null, [
          _createTextVNode("ご返信先メールアドレス："),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((mail).value = $event)),
            class: "form-control",
            type: "text"
          }, null, 512), [
            [_vModelText, mail.value]
          ])
        ])
      ]),
      _createTextVNode(" お問い合わせ内容： "),
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((comment).value = $event)),
        class: "form-control",
        style: {"width":"100%","min-height":"100px"}
      }, " ", 512), [
        [_vModelText, comment.value]
      ])
    ]),
    _: 1
  }, 8, ["id", "title"]))
}
}

})